import { Link, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Banner from '../components/banner';

interface RenewalAlert {
  message: ReactNode;
  daysUntilRebill: number;
}

interface MissingPaymentMethodBannerProps {
  hasPaymentMethods: boolean;
  renewalAlert: RenewalAlert | null;
}

export default function MissingPaymentMethodBanner({
  hasPaymentMethods,
  renewalAlert,
}: MissingPaymentMethodBannerProps) {
  if (hasPaymentMethods) return null;

  return (
    <Banner>
      {renewalAlert ? (
        <>
          {renewalAlert.message}
          {renewalAlert.daysUntilRebill <= 10 && (
            <>
              {' '}
              <Link
                component={RouterLink}
                to="/dashboard/profile/billing"
                sx={{
                  color: 'primary.dark',
                  textDecoration: 'underline',
                }}
              >
                Update Payment Info
              </Link>
            </>
          )}
        </>
      ) : (
        <div>
          <Typography component="span" variant="body1" fontWeight="bold">
            Billing Update Needed
          </Typography>
          {
            ' - As part of our ongoing security updates, previously saved payment methods may no longer be available. Please '
          }
          <Link
            component={RouterLink}
            to="/dashboard/profile/billing"
            sx={{
              color: 'primary.dark',
              textDecoration: 'underline',
            }}
          >
            add a new card
          </Link>
          {' to continue making purchases.'}
        </div>
      )}
    </Banner>
  );
}
